// controller/GlobalState.js
import React, { createContext, useState } from "react";

// Create context
export const GlobalStateContext = createContext(null);

// Provider component
export const GlobalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isJobFormOpen, setIsJobFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "",
    description: "",
  });
  const [jobFormData, setJobFormData] = useState({
    fullname: '',
    email: '',
    role: '',
    phone: '',
    experience: '',
    description: '',
    resume: null,
});

  return (
    <GlobalStateContext.Provider value={{ isOpen, setIsOpen, formData, setFormData,isJobFormOpen, setIsJobFormOpen,jobFormData, setJobFormData }}>
      {children}
    </GlobalStateContext.Provider>
  );
};
